module.exports = __webpack_public_path__ + "/templates/components/tile-extended-3.twig";